export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const QtechGames = {
  spribe: {
    aviator: {
      redirectUrl: "/casino/spribe-aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Aviator.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    mines: {
      redirectUrl: "/casino/spribe/mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Mines.webp",
      alt: "",
      name: "Mines",
      providerName: "Spribe",
    },
    goal: {
      redirectUrl: "/casino/spribe/goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Goal.webp",
      alt: "",
      name: "Goal",
      providerName: "Spribe",
    },
    dice: {
      redirectUrl: "/casino/spribe/dice",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Dice.webp",
      alt: "",
      name: "Dice",
      providerName: "Spribe",
    },
    plinko: {
      redirectUrl: "/casino/spribe/plinko",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Plinko.webp",
      alt: "",
      name: "Plinko",
      providerName: "Spribe",
    },
    miniroulette: {
      redirectUrl: "/casino/spribe/miniroulette",
      code: "mini-roulette",
      casino: "spribe",
      provider: "mini-roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/MiniROulette.webp",
      alt: "",
      name: "Mini Roulette",
      providerName: "Spribe",
    },
    hilo: {
      redirectUrl: "/casino/spribe/hilo",
      code: "hi-lo",
      casino: "spribe",
      provider: "hi-lo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Hilo.webp",
      alt: "",
      name: "Hilo",
      providerName: "Spribe",
    },
    keno: {
      redirectUrl: "/casino/spribe/keno",
      code: "keno",
      casino: "spribe",
      provider: "keno",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/keno.webp",
      alt: "keno",
      name: "Keno",
      providerName: "Spribe",
    },
    hotline: {
      redirectUrl: "/casino/spribe/hotline",
      code: "hotline",
      casino: "spribe",
      provider: "hotline",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/hotline.webp",
      alt: "hotline",
      name: "hotline",
      providerName: "Spribe",
    },
  },
  colorgame: {
   
    colorgamekingmidas: {
      redirectUrl: "/casino/aggapkingmidasgaming-color-game",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/color-game/colorgamekingmidas.jpg",
      alt: "",
      name: "Color Game",
      providerName: "Kingmidas",
    },
    colorgamejili: {
      redirectUrl: "/casino/aggapjiligaming-color-game",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/color-game/colorgamejili.jpg",
      alt: "",
      name: "Color Game",
      providerName: "JiLi Gaming",
    },
    ColorPrediction: {
      redirectUrl: "/casino/aggapjiligaming-color-prediction",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/color-game/colorprediction.jpg",
      alt: "",
      name: "Color Prediction",
      providerName: "JiLi Gaming",
    },
    colordishrich88: {
      redirectUrl: "/casino/aggaprich88-color-dish-2",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/color-game/ColorDish2.jpg",
      alt: "",
      name: "Color Dish 2",
      providerName: "RICH88",
    },
    ColorsHacksaw: {
      redirectUrl: "/casino/aggaphacksawgaming-colors",
      code: "mini-roulette",
      casino: "spribe",
      provider: "mini-roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/color-game/colorshacksaw.jpg",
      alt: "",
      name: "Colors",
      providerName: "Hacksaw Gaming",
    },
    ColorGameSupernowa: {
      redirectUrl: "/casino/sn-color-game",
      code: "hi-lo",
      casino: "spribe",
      provider: "hi-lo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/color-game/colorgamesupernowa.jpg",
      alt: "",
      name: "Color Game",
      providerName: "Supernowa",
    },
    colorgamerich88: {
      redirectUrl: "/casino/aggaprich88-color-game",
      code: "keno",
      casino: "spribe",
      provider: "keno",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/color-game/colorgamercih88.jpg",
      alt: "Color Game",
      name: "Color Game",
      providerName: "RICH88",
    },
  },

  turbo: {
    // aero: {
    //   redirectUrl: "/casino/qt-aeronauts",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/Aero.webp",
    //   alt: "",
    //   name: "Aero",
    //   providerName: "Turbo Games",
    // },
    // BallAndBall: {
    //   redirectUrl: "/casino/qt-ballandball",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/Ball&Ball.webp",
    //   alt: "",
    //   name: "Ball & Ball",
    //   providerName: "Turbo Games",
    // },
    Bayraktar: {
      redirectUrl: "/casino/qt-bayraktar",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/Bayraktar.webp",
      alt: "",
      name: "Bayraktar",
      providerName: "Turbo Games",
    },
    Bubbles: {
      redirectUrl: "/casino/qt-bubbles",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/Bubbles.webp",
      alt: "",
      name: "Bubbles",
      providerName: "Turbo Games",
    },
    // crashX: {
    //   redirectUrl: "/casino/qtechturbogames-crash-x",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/CrashX.webp",
    //   alt: "",
    //   name: "Crash X",
    //   providerName: "Turbo Games",
    // },
    // CrashXFootballEdition: {
    //   redirectUrl: "/casino/qtechturbogames-crash-x-football-edition",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/CrashXFootballEdition.webp",
    //   alt: "",
    //   name: "Crash X Football Edition",
    //   providerName: "Turbo Games",
    // },
    DiceTwice: {
      redirectUrl: "/casino/qt-dice-twice",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/DiceTwice.webp",
      alt: "",
      name: "Dice Twice",
      providerName: "Turbo Games",
    },
    // DogsStreet: {
    //   redirectUrl: "/casino/qtechturbogames-dogs-street",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/DogsStreet.webp",
    //   alt: "",
    //   name: "Dogs' Street",
    //   providerName: "Turbo Games",
    // },
    DoubleRoll: {
      redirectUrl: "/casino/qt-double-roll",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/DoubleRoll.webp",
      alt: "",
      name: "Double Roll",
      providerName: "Turbo Games",
    },
    FastFielder: {
      redirectUrl: "/casino/qt-fast-fielder",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/FastFielder.webp",
      alt: "",
      name: "Fast Fielder",
      providerName: "Turbo Games",
    },
    FruitTowers: {
      redirectUrl: "/casino/qt-fruit-towers",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/FruitTowers.webp",
      alt: "",
      name: "Fruit Towers",
      providerName: "Turbo Games",
    },
    Hamsta: {
      redirectUrl: "/casino/qt-hamsta",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/Hamsta.webp",
      alt: "",
      name: "Hamsta",
      providerName: "Turbo Games",
    },
    // HiLo: {
    //   redirectUrl: "/casino/qtechturbogames-hi-lo",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/Hi-Lo.webp",
    //   alt: "",
    //   name: "Hi-Lo",
    //   providerName: "Turbo Games",
    // },
    JavelinX: {
      redirectUrl: "/casino/qt-javelinx",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/JavelinX.webp",
      alt: "",
      name: "JavelinX",
      providerName: "Turbo Games",
    },
    LimboRider: {
      redirectUrl: "/casino/qt-limbo-rider",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/LimboRider.webp",
      alt: "",
      name: "Limbo Rider",
      providerName: "Turbo Games",
    },
    Mines: {
      redirectUrl: "/casino/qt-mines",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/Mines.webp",
      alt: "",
      name: "Mines",
      providerName: "Turbo Games",
    },
    Neko: {
      redirectUrl: "/casino/qt-neko",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/Neko.webp",
      alt: "",
      name: "Neko",
      providerName: "Turbo Games",
    },
    SaveThePrincess: {
      redirectUrl: "/casino/qt-save-the-princess",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/SaveThePrincess.webp",
      alt: "",
      name: "Save the Princess",
      providerName: "Turbo Games",
    },
    SpinStrike: {
      redirectUrl: "/casino/qt-spin-strike",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/SpinStrike.webp",
      alt: "",
      name: "Spin Strike",
      providerName: "Turbo Games",
    },
    Stairs: {
      redirectUrl: "/casino/qt-stairs",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/Stairs.webp",
      alt: "",
      name: "Stairs",
      providerName: "Turbo Games",
    },
    TradingDice: {
      redirectUrl: "/casino/qt-trading-dice",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/TradingDice.webp",
      alt: "",
      name: "Trading Dice",
      providerName: "Turbo Games",
    },
    Towers: {
      redirectUrl: "/casino/qt-towers",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/Towers.webp",
      alt: "",
      name: "Towers",
      providerName: "Turbo Games",
    },
    TurboMines: {
      redirectUrl: "/casino/qt-turbo-mines",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/TurboMines.webp",
      alt: "",
      name: "Turbo Mines",
      providerName: "Turbo Games",
    },
    TurboPlinko: {
      redirectUrl: "/casino/qt-plinko",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/TurboPlinko.webp",
      alt: "",
      name: "Turbo Plinko",
      providerName: "Turbo Games",
    },
    WicketBlast: {
      redirectUrl: "/casino/qt-wicket-blast",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/WicketBlast.webp",
      alt: "",
      name: "Wicket Blast",
      providerName: "Turbo Games",
    },
    MagicKeno: {
      redirectUrl: "/casino/qt-magic-keno",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/MagicKeno.webp",
      alt: "",
      name: "Magic Keno",
      providerName: "Turbo Games",
    },
    Vortex: {
      redirectUrl: "/casino/qt-dark-vortex",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/Vortex.webp",
      alt: "",
      name: "Vortex",
      providerName: "Turbo Games",
    },
    Tap1MinesU6564: {
      redirectUrl: "/casino/qt-1tap-mines",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/1TapMines(InstantWin).webp",
      alt: "",
      name: "1Tap Mines",
      providerName: "Turbo Games",
    },
    // TakeMyPlinko: {
    //   redirectUrl: "/casino/qtechturbogames-take-my-plinko-u2745",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/TakeMyPlinko.webp",
    //   alt: "",
    //   name: "Take My Plinko",
    //   providerName: "Turbo Games",
    // },
    // Tap1Mines: {
    //   redirectUrl: "/casino/qtechturbogames-1tap-mines",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/1TapMines.webp",
    //   alt: "",
    //   name: "1Tap Mines (Instant Win)",
    //   providerName: "Turbo Games",
    // },
    // DiceThrice: {
    //   redirectUrl: "/casino/qtechturbogames-dice-thrice",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/DiceThrice.webp",
    //   alt: "",
    //   name: "Dice Thrice",
    //   providerName: "Turbo Games",
    // },
    // PumpedX: {
    //   redirectUrl: "/casino/qtechturbogames-pumpedx",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/PumpedX.webp",
    //   alt: "",
    //   name: "PumpedX",
    //   providerName: "Turbo Games",
    // },
    // DonnyKing: {
    //   redirectUrl: "/casino/qtechturbogames-donny-king",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/DonnyKing.webp",
    //   alt: "",
    //   name: "Donny King",
    //   providerName: "Turbo Games",
    // },
    // CrystalPoker: {
    //   redirectUrl: "/casino/qtechturbogames-crystal-poker",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/CrystalPoker.webp",
    //   alt: "",
    //   name: "Crystal Poker",
    //   providerName: "Turbo Games",
    // },
    // MultiplayerMines: {
    //   redirectUrl: "/casino/qtechturbogames-multiplayer-mines",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/MultiplayerMines.webp",
    //   alt: "",
    //   name: "Multiplayer Mines",
    //   providerName: "Turbo Games",
    // },
    BookOfMines: {
      redirectUrl: "/casino/qt-book-of-mines",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/turbo/BookOfMines.webp",
      alt: "",
      name: "Book of Mines",
      providerName: "Turbo Games",
    },
    // JewelClicker: {
    //   redirectUrl: "/casino/qtechturbogames-jewel-clicker",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/turbo/JewelClicker.webp",
    //   alt: "",
    //   name: "Jewel Clicker",
    //   providerName: "Turbo Games",
    // },

    // name: "Turbo",
    // key: "turbo",
  },

  hacksaw: {
    SCRATCHPlatinum: {
      redirectUrl: "/casino/qtechhacksawgaming-scratch-platinum",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/SCRATCHPlatinum.webp",
      alt: "",
      name: "SCRATCH! Platinum",
      providerName: "Hacksaw",
    },
    SCRATCHGold: {
      redirectUrl: "/casino/qtechhacksawgaming-scratch-gold",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/SCRATCHGold.webp",
      alt: "",
      name: "SCRATCH! Gold",
      providerName: "Hacksaw",
    },
    SCRATCHSilver: {
      redirectUrl: "/casino/qtechhacksawgaming-scratch-silver",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/SCRATCHSilver.webp",
      alt: "",
      name: "SCRATCH! Silver",
      providerName: "Hacksaw",
    },
    SCRATCHBronze: {
      redirectUrl: "/casino/qtechhacksawgaming-scratch-bronze",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/SCRATCHBronze.webp",
      alt: "",
      name: "SCRATCH! Bronze",
      providerName: "Hacksaw",
    },
    SnowScratcher: {
      redirectUrl: "/casino/qtechhacksawgaming-snow-scratcher",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/SnowScratcher.webp",
      alt: "",
      name: "Snow Scratcher",
      providerName: "Hacksaw",
    },
    SummerScratch: {
      redirectUrl: "/casino/qtechhacksawgaming-summer-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/SummerScratch.webp",
      alt: "",
      name: "Summer Scratch",
      providerName: "Hacksaw",
    },
    Express200Scratch: {
      redirectUrl: "/casino/qtechhacksawgaming-express-200-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/Express200Scratch.webp",
      alt: "",
      name: "Express 200 Scratch",
      providerName: "Hacksaw",
    },
    ScratchyMini: {
      redirectUrl: "/casino/qtechhacksawgaming-scratchy-mini",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/ScratchyMini.webp",
      alt: "",
      name: "Scratchy Mini",
      providerName: "Hacksaw",
    },
    Scratchy: {
      redirectUrl: "/casino/qtechhacksawgaming-scratchy",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/Scratchy.webp",
      alt: "",
      name: "Scratchy",
      providerName: "Hacksaw",
    },
    ScratchyBig: {
      redirectUrl: "/casino/qtechhacksawgaming-scratchy-big",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/ScratchyBig.webp",
      alt: "",
      name: "Scratchy Big",
      providerName: "Hacksaw",
    },
    KingTreasure: {
      redirectUrl: "/casino/qtechhacksawgaming-king-treasure",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/KingTreasure.webp",
      alt: "",
      name: "King Treasure",
      providerName: "Hacksaw",
    },
    QueenTreasure: {
      redirectUrl: "/casino/qtechhacksawgaming-queen-treasure",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/QueenTreasure.webp",
      alt: "",
      name: "Queen Treasure",
      providerName: "Hacksaw",
    },
    PrinceTreasure: {
      redirectUrl: "/casino/qtechhacksawgaming-prince-treasure",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/PrinceTreasure.webp",
      alt: "",
      name: "Prince Treasure",
      providerName: "Hacksaw",
    },
    HappyScratch: {
      redirectUrl: "/casino/qtechhacksawgaming-happy-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/Happyscratch.webp",
      alt: "",
      name: "Happy Scratch",
      providerName: "Hacksaw",
    },
    LOVEIsAllYouNeed: {
      redirectUrl: "/casino/qtechhacksawgaming-love-is-all-you-need",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/LoveIsAllYouNeed.webp",
      alt: "",
      name: "LOVE is all you need",
      providerName: "Hacksaw",
    },
    LuckyScratch: {
      redirectUrl: "/casino/qtechhacksawgaming-lucky-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/Luckyscratch.webp",
      alt: "",
      name: "Lucky Scratch",
      providerName: "Hacksaw",
    },
    CashPool: {
      redirectUrl: "/casino/qtechhacksawgaming-cash-pool",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/Cashpool.webp",
      alt: "",
      name: "Cash Pool",
      providerName: "Hacksaw",
    },
    CashScratch: {
      redirectUrl: "/casino/qtechhacksawgaming-cash-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/CashScratch.webp",
      alt: "",
      name: "Cash Scratch",
      providerName: "Hacksaw",
    },
    ChaosCrewScratch: {
      redirectUrl: "/casino/qtechhacksawgaming-chaos-crew-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/ChaosCrewScratch.webp",
      alt: "",
      name: "Chaos Crew Scratch",
      providerName: "Hacksaw",
    },
    DreamCarUrban: {
      redirectUrl: "/casino/qtechhacksawgaming-dream-car-urban",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/DreamCarUrban.webp",
      alt: "",
      name: "Dream Car Urban",
      providerName: "Hacksaw",
    },
    DreamCarSUV: {
      redirectUrl: "/casino/qtechhacksawgaming-dream-car-suv",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/DreamCarSUV.webp",
      alt: "",
      name: "Dream Car SUV",
      providerName: "Hacksaw",
    },
    DreamCarSpeed: {
      redirectUrl: "/casino/qtechhacksawgaming-dream-car-speed",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/DreamCarSpeed.webp",
      alt: "",
      name: "Dream Car Speed",
      providerName: "Hacksaw",
    },
    EggstraCash: {
      redirectUrl: "/casino/qtechhacksawgaming-eggstra-cash",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/EggstraCash.webp",
      alt: "",
      name: "Eggstra Cash",
      providerName: "Hacksaw",
    },
    FootballScratch: {
      redirectUrl: "/casino/qtechhacksawgaming-football-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/FootballScratch.webp",
      alt: "",
      name: "Football Scratch",
      providerName: "Hacksaw",
    },
    GoldRush: {
      redirectUrl: "/casino/qtechhacksawgaming-gold-rush",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/GoldRush.webp",
      alt: "",
      name: "Gold Rush",
      providerName: "Hacksaw",
    },
    RubyRush: {
      redirectUrl: "/casino/qtechhacksawgaming-ruby-rush",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/RubyRush.webp",
      alt: "",
      name: "Ruby Rush",
      providerName: "Hacksaw",
    },
    DiamondRush: {
      redirectUrl: "/casino/qtechhacksawgaming-diamond-rush",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/DiamondRush.webp",
      alt: "",
      name: "Diamond Rush",
      providerName: "Hacksaw",
    },
    LuckyShot: {
      redirectUrl: "/casino/qtechhacksawgaming-lucky-shot",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/LuckyShot.webp",
      alt: "",
      name: "Lucky Shot",
      providerName: "Hacksaw",
    },
    CashVaultI: {
      redirectUrl: "/casino/qtechhacksawgaming-cash-vault-i",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/CashVaultI.webp",
      alt: "",
      name: "Cash Vault I",
      providerName: "Hacksaw",
    },
    CashVaultII: {
      redirectUrl: "/casino/qtechhacksawgaming-cash-vault-ii",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/hacksaw/CashVaultII.webp",
      alt: "",
      name: "Cash Vault II",
      providerName: "Hacksaw",
    },
  },

  instantGames: {
    Blastoff: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blastoff",
      name: "Blastoff",
      providerName: "aura",
      imgUrl: "./images/aura/Blastoff.webp",
      redirectUrl: "/casino/aura-blastoff",
    },
    FortuneWheel: {
      code: "70001",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Wheel",
      name: "Fortune Wheel",
      providerName: "aura",
      imgUrl: "./images/aura/FortuneWheel.webp",
      redirectUrl: "/casino/aura-fortune-wheel",
    },
    CoinToss: {
      code: "70003",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Coin Toss",
      name: "Coin Toss",
      providerName: "aura",
      imgUrl: "./images/aura/CoinToss.webp",
      redirectUrl: "/casino/aura-coin-toss",
    },
    Limbo: {
      code: "70004",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Limbo",
      name: "Limbo",
      providerName: "aura",
      imgUrl: "./images/aura/Limbo.webp",
      redirectUrl: "/casino/aura-limbo",
    },
    SlotGame: {
      code: "70005",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Slot Game",
      name: "Slot Game",
      providerName: "aura",
      imgUrl: "./images/aura/SlotGame.webp",
      redirectUrl: "/casino/aura-slot-game",
    },
    RockPaperScissors: {
      code: "70006",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rock Paper Scissors",
      name: "Rock Paper Scissors",
      providerName: "aura",
      imgUrl: "./images/aura/RockPaperScissors.webp",
      redirectUrl: "/casino/aura-rock-paper-scissors",
    },
    Cricket: {
      code: "70008",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket",
      name: "Cricket",
      providerName: "aura",
      imgUrl: "./images/aura/Cricket.webp",
      redirectUrl: "/casino/aura-cricket",
    },
    ClassicDice: {
      code: "70009",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Classic Dice",
      name: "Classic Dice",
      providerName: "aura",
      imgUrl: "./images/aura/ClassicDice.webp",
      redirectUrl: "/casino/aura-classic-dice",
    },
    Mines: {
      code: "70011",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines",
      name: "Mines",
      providerName: "aura",
      imgUrl: "./images/aura/Mines.webp",
      redirectUrl: "/casino/aura-mines",
    },
    Aviator: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Aviator",
      name: "Aviator",
      providerName: "aura",
      imgUrl: "./images/aura/Aviator.webp",
      redirectUrl: "/casino/aura-aviator",
    },
  },
  mac88Gaming: {
    RockPaperScissors: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rock Paper Scissors",
      name: "Rock Paper Scissors",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/rockpaperscissors.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
    },
    Boys5: {
      code: "67720",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5 Boys",
      name: "5 Boys",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/5boys.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5-boys",
    },
    JetXT: {
      code: "92037",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jet XT",
      name: "Jet XT",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/jetxt.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-jet-xt",
    },
    Kitex: {
      code: "92038",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kitex",
      name: "Kitex",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/kitex.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kitex",
    },
    HiLo: {
      code: "67610",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi Lo",
      name: "Hi Lo",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/hi-lo.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo",
    },
    PushpaRani: {
      code: "67670",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pushpa Rani",
      name: "Pushpa Rani",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/pushparani.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-pushpa-rani",
    },
    BallbyBallVR: {
      code: "90100",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ball by Ball VR",
      name: "Ball by Ball VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/ballbyballvr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
    },
    XRoulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "X Roulette",
      name: "X Roulette",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/xroulette.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-x-roulette",
    },
    Lucky15: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 15",
      name: "Lucky 15",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/lucky15.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-15",
    },
    Vortex: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Vortex",
      name: "Vortex",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/vortex.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vortex",
    },
    BollyKiss: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bolly Kiss",
      name: "Bolly Kiss",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/bollykiss.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-bolly-kiss",
    },
    Plinko: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Plinko",
      name: "Plinko",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/plinko.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-plinko",
    },
    diamonds: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Diamond",
      name: "Diamond",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/diamonds.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-diamonds",
    },
    mines: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines",
      name: "Mines",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/mines.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-mines",
    },
    Limbo: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Limbo",
      name: "Limbo",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/limbo.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-limbo",
    },
    CrashX: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash X",
      name: "Crash X",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/crashx.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-crash-x",
    },
    Dice: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice",
      name: "Dice",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/Dice.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-dice",
    },
    AK47VR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "AK47 VR",
      name: "AK47 VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/ak47vr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ak47-vr",
    },
    KaunBanegaCrorepatiVR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kaun Banega Crorepati VR",
      name: "Kaun Banega Crorepati VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/kaunabanegacrorpativr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
    },
    CenterCardVR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Center Card VR",
      name: "Center Card VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-center-card-vr",
    },
    // HiloVR: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Hi Lo VR",
    //   name: "Hi Lo VR",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
    // },
    // AviatorX2: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "AviatorX2",
    //   name: "AviatorX2",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-aviatorx2",
    // },
    // K3Lottery10: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "K3 Lottery 10",
    //   name: "K3 Lottery 10",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
    // },
  },

  // galaxsys: {
  //   // ScratchMap: {
  //   //   redirectUrl: "/casino/qtechgalaxsys-scratch-map",
  //   //   code: "",
  //   //   casino: "Galaxsys",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/galaxsys/ScratchMap.webp",
  //   //   alt: "Scratch Map",
  //   //   name: "Scratch Map",
  //   //   providerName: "Galaxsys",
  //   // },
  //   // Atlantis: {
  //   //   redirectUrl: "/casino/qtechgalaxsys-atlantis",
  //   //   code: "",
  //   //   casino: "Galaxsys",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/galaxsys/Atlantis.webp",
  //   //   alt: "Atlantis",
  //   //   name: "Atlantis",
  //   //   providerName: "Galaxsys",
  //   // },
  //   // CashShow: {
  //   //   redirectUrl: "/casino/qtechgalaxsys-cash-show",
  //   //   code: "",
  //   //   casino: "Galaxsys",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/galaxsys/CashShow.webp",
  //   //   alt: "Cash Show",
  //   //   name: "Cash Show",
  //   //   providerName: "Galaxsys",
  //   // },
  //   CoinFlip: {
  //     redirectUrl: "/casino/qtechgalaxsys-coin-flip",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/CoinFlip.webp",
  //     alt: "Coin Flip",
  //     name: "Coin Flip",
  //     providerName: "Galaxsys",
  //   },
  //   Crash: {
  //     redirectUrl: "/casino/qtechgalaxsys-crash",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Crash.webp",
  //     alt: "Crash",
  //     name: "Crash",
  //     providerName: "Galaxsys",
  //   },
  //   // Crasher: {
  //   //   redirectUrl: "/casino/qtechgalaxsys-crasher",
  //   //   code: "",
  //   //   casino: "Galaxsys",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/galaxsys/Crasher.webp",
  //   //   alt: "Crasher",
  //   //   name: "Crasher",
  //   //   providerName: "Galaxsys",
  //   // },
  //   JungleWheel: {
  //     redirectUrl: "/casino/qtechgalaxsys-jungle-wheel",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/JungleWheel.webp",
  //     alt: "Jungle Wheel",
  //     name: "Jungle Wheel",
  //     providerName: "Galaxsys",
  //   },
  //   FMines: {
  //     redirectUrl: "/casino/qtechgalaxsys-f-mines",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/FMines.webp",
  //     alt: "F Mines",
  //     name: "F Mines",
  //     providerName: "Galaxsys",
  //   },
  //   GoldenRa: {
  //     redirectUrl: "/casino/qtechgalaxsys-golden-ra",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/GoldenRa.webp",
  //     alt: "Golden Ra",
  //     name: "Golden Ra",
  //     providerName: "Galaxsys",
  //   },
  //   Hilo: {
  //     redirectUrl: "/casino/qtechgalaxsys-hilo",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Hilo.webp",
  //     alt: "Hilo",
  //     name: "Hilo",
  //     providerName: "Galaxsys",
  //   },
  //   Maestro: {
  //     redirectUrl: "/casino/qtechgalaxsys-maestro",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Maestro.webp",
  //     alt: "Maestro",
  //     name: "Maestro",
  //     providerName: "Galaxsys",
  //   },
  //   MrThimbl: {
  //     redirectUrl: "/casino/qtechgalaxsys-mr-thimbl",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/MrThimbl.webp",
  //     alt: "Mr Thimbl",
  //     name: "Mr Thimbl",
  //     providerName: "Galaxsys",
  //   },
  //   NinjaCrash: {
  //     redirectUrl: "/casino/qtechgalaxsys-ninja-crash",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/NinjaCrash.webp",
  //     alt: "Ninja Crash",
  //     name: "Ninja Crash",
  //     providerName: "Galaxsys",
  //   },
  //   Penalty: {
  //     redirectUrl: "/casino/qtechgalaxsys-penalty",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Penalty.webp",
  //     alt: "Penalty",
  //     name: "Penalty",
  //     providerName: "Galaxsys",
  //   },
  //   Plinkoman: {
  //     redirectUrl: "/casino/qtechgalaxsys-plinkoman",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Plinkoman.webp",
  //     alt: "Plinkoman",
  //     name: "Plinkoman",
  //     providerName: "Galaxsys",
  //   },
  //   Rocketon: {
  //     redirectUrl: "/casino/qtechgalaxsys-rocketon",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Rocketon.webp",
  //     alt: "Rocketon",
  //     name: "Rocketon",
  //     providerName: "Galaxsys",
  //   },
  //   TurboMines: {
  //     redirectUrl: "/casino/qtechgalaxsys-turbo-mines",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/TurboMines.webp",
  //     alt: "Turbo Mines",
  //     name: "Turbo Mines",
  //     providerName: "Galaxsys",
  //   },
  //   BingoStar: {
  //     redirectUrl: "/casino/qtechgalaxsys-bingo-star",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/BingoStar.webp",
  //     alt: "Bingo Star",
  //     name: "Bingo Star",
  //     providerName: "Galaxsys",
  //   },
  //   Keno10Minute1: {
  //     redirectUrl: "/casino/qtechgalaxsys-keno-10-1-minute",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Keno10Minute1.webp",
  //     alt: "Keno 10 (1 Minute)",
  //     name: "Keno 10 (1 Minute)",
  //     providerName: "Galaxsys",
  //   },
  //   Keno10Minute2: {
  //     redirectUrl: "/casino/qtechgalaxsys-keno-10-2-minute",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Keno10Minute2.webp",
  //     alt: "Keno 10 (2 Minute)",
  //     name: "Keno 10 (2 Minute)",
  //     providerName: "Galaxsys",
  //   },
  //   Keno8Minute1: {
  //     redirectUrl: "/casino/qtechgalaxsys-keno-8-1-minute",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Keno8Minute1.webp",
  //     alt: "Keno 8 (1 Minute)",
  //     name: "Keno 8 (1 Minute)",
  //     providerName: "Galaxsys",
  //   },
  //   Keno8Minute2: {
  //     redirectUrl: "/casino/qtechgalaxsys-keno-8-2-minute",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Keno8Minute2.webp",
  //     alt: "Keno 8 (2 Minute)",
  //     name: "Keno 8 (2 Minute)",
  //     providerName: "Galaxsys",
  //   },
  //   KenoExpress: {
  //     redirectUrl: "/casino/qtechgalaxsys-keno-express",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/KenoExpress.webp",
  //     alt: "Keno Express",
  //     name: "Keno Express",
  //     providerName: "Galaxsys",
  //   },
  //   BlackJack: {
  //     redirectUrl: "/casino/qtechgalaxsys-blackjack",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/BlackJack.webp",
  //     alt: "BlackJack",
  //     name: "BlackJack",
  //     providerName: "Galaxsys",
  //   },
  //   RouletteX: {
  //     redirectUrl: "/casino/qtechgalaxsys-roulette-x",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/RouletteX.webp",
  //     alt: "Roulette X",
  //     name: "Roulette X",
  //     providerName: "Galaxsys",
  //   },

  //   // BackgammonAsian: {
  //   //   redirectUrl: "/casino/qtechgalaxsys-backgammon-asian-u6980",
  //   //   code: "",
  //   //   casino: "Galaxsys",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/galaxsys/BackgammonAsian.webp",
  //   //   alt: "Backgammon Asian",
  //   //   name: "Backgammon Asian",
  //   //   providerName: "Galaxsys",
  //   // },
  //   SicBo: {
  //     redirectUrl: "/casino/qtechgalaxsys-sicbo",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/SicBoGalaxsys.webp",
  //     alt: "SicBo",
  //     name: "SicBo",
  //     providerName: "Galaxsys",
  //   },
  //   CosmoSaga: {
  //     redirectUrl: "/casino/qtechgalaxsys-cosmo-saga",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/CosmoSaga.webp",
  //     alt: "Cosmo Saga",
  //     name: "Cosmo Saga",
  //     providerName: "Galaxsys",
  //   },
  //   DrShocker: {
  //     redirectUrl: "/casino/qtechgalaxsys-dr-shocker",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/DrShocker.webp",
  //     alt: "Dr Shocker",
  //     name: "Dr Shocker",
  //     providerName: "Galaxsys",
  //   },
  //   HotGear: {
  //     redirectUrl: "/casino/qtechgalaxsys-hot-gear",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/HotGear.webp",
  //     alt: "Hot Gear",
  //     name: "Hot Gear",
  //     providerName: "Galaxsys",
  //   },
  //   LottoBoom: {
  //     redirectUrl: "/casino/qtechgalaxsys-lotto-boom",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/LottoBoom.webp",
  //     alt: "Lotto Boom",
  //     name: "Lotto Boom",
  //     providerName: "Galaxsys",
  //   },
  //   TowerRush: {
  //     redirectUrl: "/casino/qtechgalaxsys-tower-rush",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/TowerRush.webp",
  //     alt: "Tower Rush",
  //     name: "Tower Rush",
  //     providerName: "Galaxsys",
  //   },
  //   LimboCrash: {
  //     redirectUrl: "/casino/qtechgalaxsys-limbo-crash",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/LimboCrash.webp",
  //     alt: "Limbo Crash",
  //     name: "Limbo Crash",
  //     providerName: "Galaxsys",
  //   },
  //   SlapShot: {
  //     redirectUrl: "/casino/qtechgalaxsys-slap-shot",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/SlapShot.webp",
  //     alt: "Slap Shot",
  //     name: "Slap Shot",
  //     providerName: "Galaxsys",
  //   },
  // },

  // smartSoft: {
  //   JetX: {
  //     redirectUrl: "/casino/qtechsmartsoft-jetx-u5599",
  //     code: "",
  //     casino: "SmartSoft",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/smartsoft/JetX.webp",
  //     alt: "JetX",
  //     name: "JetX",
  //     providerName: "SmartSoft",
  //   },
  //   // Cappadocia: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-cappadocia-u9350",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Cappadocia.webp",
  //   //   alt: "Cappadocia",
  //   //   name: "Cappadocia",
  //   //   providerName: "SmartSoft",
  //   // },
  //   JetX3: {
  //     redirectUrl: "/casino/qtechsmartsoft-jetx3-u2767",
  //     code: "",
  //     casino: "SmartSoft",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/smartsoft/JetX3.webp",
  //     alt: "JetX3",
  //     name: "JetX3",
  //     providerName: "SmartSoft",
  //   },
  //   // SpinX: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-spinx-u5864",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/SpinX.webp",
  //   //   alt: "SpinX",
  //   //   name: "SpinX",
  //   //   providerName: "SmartSoft",
  //   // },
  //   Balloon: {
  //     redirectUrl: "/casino/qtechsmartsoft-balloon",
  //     code: "",
  //     casino: "SmartSoft",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/smartsoft/Balloon.webp",
  //     alt: "Balloon",
  //     name: "Balloon",
  //     providerName: "SmartSoft",
  //   },
  //   CricketX: {
  //     redirectUrl: "/casino/qtechsmartsoft-cricketx-u6818",
  //     code: "",
  //     casino: "SmartSoft",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/smartsoft/CricketX.webp",
  //     alt: "CricketX",
  //     name: "CricketX",
  //     providerName: "SmartSoft",
  //   },
  //   PlinkoX: {
  //     redirectUrl: "/casino/qtechsmartsoft-plinkox-u6950",
  //     code: "",
  //     casino: "SmartSoft",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/smartsoft/PlinkoX.webp",
  //     alt: "PlinkoX",
  //     name: "PlinkoX",
  //     providerName: "SmartSoft",
  //   },
  //   FootballX: {
  //     redirectUrl: "/casino/qtechsmartsoft-footballx-u9400",
  //     code: "",
  //     casino: "SmartSoft",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/smartsoft/FootballX.webp",
  //     alt: "FootballX",
  //     name: "FootballX",
  //     providerName: "SmartSoft",
  //   },
  //   CrazyHuntX: {
  //     redirectUrl: "/casino/qtechsmartsoft-crazy-huntx-u7133",
  //     code: "",
  //     casino: "SmartSoft",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/smartsoft/CrazyHuntX.webp",
  //     alt: "Crazy HuntX",
  //     name: "Crazy HuntX",
  //     providerName: "SmartSoft",
  //   },
  //   DoubleX: {
  //     redirectUrl: "/casino/qtechsmartsoft-doublex-u4408",
  //     code: "",
  //     casino: "SmartSoft",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/smartsoft/DoubleX.webp",
  //     alt: "DoubleX",
  //     name: "DoubleX",
  //     providerName: "SmartSoft",
  //   },
  //   // TowerX: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-towerx-u6571",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/TowerX.webp",
  //   //   alt: "TowerX",
  //   //   name: "TowerX",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Jokers4Bonuses: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-jokers-4-bonuses-u3686",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Jokers4Bonuses.webp",
  //   //   alt: "Joker's 4 Bonuses",
  //   //   name: "Joker's 4 Bonuses",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Viking: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-viking-u3550",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Viking.webp",
  //   //   alt: "Viking",
  //   //   name: "Viking",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Aztec: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-aztec-u9211",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Aztec.webp",
  //   //   alt: "Aztec",
  //   //   name: "Aztec",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Cowboy: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-cowboy-u5088",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Cowboy.webp",
  //   //   alt: "Cowboy",
  //   //   name: "Cowboy",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // BookOfWin: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-book-of-win-u2510",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/BookOfWin.webp",
  //   //   alt: "Book of Win",
  //   //   name: "Book of Win",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Samurai: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-samurai-u9593",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Samurai.webp",
  //   //   alt: "Samurai",
  //   //   name: "Samurai",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // MoonStone: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-moonstone-u9590",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/MoonStone.webp",
  //   //   alt: "MoonStone",
  //   //   name: "MoonStone",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Apollo: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-apollo-u8093",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Apollo.webp",
  //   //   alt: "Apollo",
  //   //   name: "Apollo",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Evolution: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-evolution-u7308",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Evolution.webp",
  //   //   alt: "Evolution",
  //   //   name: "Evolution",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // BurningIce: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-burning-ice-u5133",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/BurningIce.webp",
  //   //   alt: "Burning Ice",
  //   //   name: "Burning Ice",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // MagicGarden: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-magic-garden-u4134",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/MagicGarden.webp",
  //   //   alt: "Magic Garden",
  //   //   name: "Magic Garden",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // BurningIce10: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-burning-ice-10-u5952",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/BurningIce10.webp",
  //   //   alt: "Burning Ice 10",
  //   //   name: "Burning Ice 10",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // MagicGarden10: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-magic-garden-10-u4108",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/MagicGarden10.webp",
  //   //   alt: "Magic Garden 10",
  //   //   name: "Magic Garden 10",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // BurningIce40: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-burning-ice-40-u3286",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/BurningIce40.webp",
  //   //   alt: "Burning Ice 40",
  //   //   name: "Burning Ice 40",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // MagicGarden40: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-magic-garden-40-u6329",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/MagicGarden40.webp",
  //   //   alt: "Magic Garden 40",
  //   //   name: "Magic Garden 40",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Dark: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-dark-u5991",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Dark.webp",
  //   //   alt: "Dark",
  //   //   name: "Dark",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // WorldWarII: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-world-war-ii-u8573",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/WorldWarII.webp",
  //   //   alt: "World War II",
  //   //   name: "World War II",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // SummerCocktail: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-summer-cocktail-u3240",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/SummerCocktail.webp",
  //   //   alt: "Summer Cocktail",
  //   //   name: "Summer Cocktail",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Dark100: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-dark-100-u9404",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Dark100.webp",
  //   //   alt: "Dark 100",
  //   //   name: "Dark 100",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Vampires: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-vampires-u1755",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Vampires.webp",
  //   //   alt: "Vampires",
  //   //   name: "Vampires",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // TheKingdomOfTheElves: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-the-kingdom-of-the-elves-u4650",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/TheKingdomOfTheElves.webp",
  //   //   alt: "The Kingdom of The Elves",
  //   //   name: "The Kingdom of The Elves",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // MultiHot5: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-multi-hot-5-u7668",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/MultiHot5.webp",
  //   //   alt: "Multi Hot 5",
  //   //   name: "Multi Hot 5",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Zombies: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-zombies-u2367",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Zombies.webp",
  //   //   alt: "Zombies",
  //   //   name: "Zombies",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // WildJungle: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-wild-jungle-u2194",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/WildJungle.webp",
  //   //   alt: "Wild Jungle",
  //   //   name: "Wild Jungle",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // SweetCocktail: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-sweet-cocktail-u8472",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/SweetCocktail.webp",
  //   //   alt: "Sweet Cocktail",
  //   //   name: "Sweet Cocktail",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // CrazyApe: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-crazy-ape-u1544",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/CrazyApe.webp",
  //   //   alt: "Crazy Ape",
  //   //   name: "Crazy Ape",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // ParaDice10: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-para-dice-10-u6786",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/ParaDice10.webp",
  //   //   alt: "Para Dice 10",
  //   //   name: "Para Dice 10",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Babylon: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-babylon-u1392",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Babylon.webp",
  //   //   alt: "Babylon",
  //   //   name: "Babylon",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // GeniesBonanza: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-genies-bonanza-u3200",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/GeniesBonanza.webp",
  //   //   alt: "Genie's Bonanza",
  //   //   name: "Genie's Bonanza",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // MultiHotWays: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-multi-hot-ways-u4788",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/MultiHotWays.webp",
  //   //   alt: "Multi Hot Ways",
  //   //   name: "Multi Hot Ways",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // VirtualRoulette: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-virtual-roulette-u3619",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/VirtualRoulette.webp",
  //   //   alt: "Virtual Roulette",
  //   //   name: "Virtual Roulette",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // VirtualBurningRoulette: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-virtual-burning-roulette-u5010",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/VirtualBurningRoulette.webp",
  //   //   alt: "Virtual Burning Roulette",
  //   //   name: "Virtual Burning Roulette",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // BonusRoulette: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-bonus-roulette-u2578",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/BonusRoulette.webp",
  //   //   alt: "Bonus Roulette",
  //   //   name: "Bonus Roulette",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // PersonalRoulette: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-personal-roulette-u1044",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/PersonalRoulette.webp",
  //   //   alt: "Personal Roulette",
  //   //   name: "Personal Roulette",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // VirtualClassicRoulette: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-virtual-classic-roulette-u1605",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/VirtualClassicRoulette.webp",
  //   //   alt: "Virtual Classic Roulette",
  //   //   name: "Virtual Classic Roulette",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // FrenchKeno: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-french-keno-u9013",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/FrenchKeno.webp",
  //   //   alt: "French Keno",
  //   //   name: "French Keno",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // RussianKeno: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-russian-keno-u1034",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/RussianKeno.webp",
  //   //   alt: "Russian Keno",
  //   //   name: "Russian Keno",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // VIPKeno: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-vip-keno-u7016",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/VIPKeno.webp",
  //   //   alt: "VIP Keno",
  //   //   name: "VIP Keno",
  //   //   providerName: "SmartSoft",
  //   // },
  //   // Argo: {
  //   //   redirectUrl: "/casino/qtechsmartsoft-argo-u6076",
  //   //   code: "",
  //   //   casino: "SmartSoft",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/smartsoft/Argo.webp",
  //   //   alt: "Argo",
  //   //   name: "Argo",
  //   //   providerName: "SmartSoft",
  //   // },
  // },
};
